import { Controller } from "@hotwired/stimulus"

const AUTO_SCROLL_THRESHOLD = 100

export default class extends Controller {
  static pendingOperations = Promise.resolve()

  connect() {
    this.autoscroll(true)
    this.isLoadingMore = false
  }

  async autoscroll(forceScroll, render = () => {}) {
    return this.appendOperation(async () => {
      const wasNearEnd = this.isScrolledNearEnd()

      await render()
      await this.nextEventLoopTick()

      if (wasNearEnd || forceScroll) {
        this.element.scrollTop = this.element.scrollHeight
        return true
      }

      return false
    })
  }

  async beforeStreamRender(event) {
    const target = event.detail.newStream.getAttribute("target")
    const action = event.detail.newStream.getAttribute("action")

    console.log('Stream render:', { target, action, elementId: this.element.id })

    if (target === this.element.id && action === "prepend") {
      // Handle prepending older messages - preserve scroll position
      const originalRender = event.detail.render

      event.detail.render = async (streamElement) => {
        // Capture scroll position before rendering
        const scrollHeightBefore = this.element.scrollHeight
        const scrollTopBefore = this.element.scrollTop

        console.log('Before prepend:', { scrollHeightBefore, scrollTopBefore })

        // Render new messages
        await originalRender(streamElement)

        // Use multiple animation frames to ensure layout is complete
        await new Promise(resolve => requestAnimationFrame(resolve))
        await new Promise(resolve => requestAnimationFrame(resolve))
        await new Promise(resolve => requestAnimationFrame(resolve))

        // Calculate new scroll position
        const scrollHeightAfter = this.element.scrollHeight
        const heightAdded = scrollHeightAfter - scrollHeightBefore
        const newScrollTop = scrollTopBefore + heightAdded

        console.log('After prepend:', { scrollHeightAfter, heightAdded, newScrollTop })

        // Set new scroll position
        this.element.scrollTop = newScrollTop

        console.log('Actual scrollTop:', this.element.scrollTop)
      }
    } else if (target === this.element.id && action === "append") {
      // Handle appending new messages - autoscroll if near bottom
      const originalRender = event.detail.render

      event.detail.render = async (streamElement) => {
        await this.autoscroll(false, async () => {
          await originalRender(streamElement)
          await this.nextEventLoopTick()
        })
      }
    }
  }

  appendOperation(operation) {
    this.constructor.pendingOperations = this.constructor.pendingOperations.then(operation)
    return this.constructor.pendingOperations
  }

  isScrolledNearEnd() {
    const distanceFromEnd = this.element.scrollHeight - this.element.scrollTop - this.element.clientHeight
    return distanceFromEnd <= AUTO_SCROLL_THRESHOLD
  }

  nextEventLoopTick() {
    return new Promise(resolve => setTimeout(resolve, 0))
  }
}
